import http from '../utils/request'

/**
 * 流程管理接口 — 对应后端 ProcessController (/api/process)
 * 底层数据获取参考 CloudWeb/Modules/DevelopManages/WorkFlow/WorkFlowMgr.aspx.cs
 *   - 目录数据: SYSCommonCATALOGInfo (Type=1 为流程目录)
 *   - 流程数据: SYSBPMDPROCESSInfo
 */

// ========== 流程目录 ==========

/** 获取流程目录树 */
export const getCatalogs = () => http.get('/process/catalogs')

/** 新增/修改流程目录 */
export const saveCatalog = (data) => http.post('/process/catalog', data)

/** 删除流程目录 */
export const deleteCatalog = (guid) => http.delete(`/process/catalog/${encodeURIComponent(guid)}`)

// ========== 流程 ==========

/** 获取指定目录下的流程列表 */
export const getProcessList = (catalogGuid) => http.get('/process/list', { params: { catalogGuid } })

/** 获取流程详情 */
export const getProcess = (guid) => http.get(`/process/${encodeURIComponent(guid)}`)

/** 新增/修改流程 */
export const saveProcess = (data) => http.post('/process', data)

/** 删除流程 */
export const deleteProcess = (guid) => http.delete(`/process/${encodeURIComponent(guid)}`)

/** 备份流程 */
export const backupProcess = (data) => http.post('/process/backup', data)

/** 导出流程 */
export const exportProcess = (data) => http.post('/process/export', data)

// ========== 数据库表设计 ==========

/** 获取流程关联的数据表列表 */
export const getDbTables = (catalogGuid) => http.get('/process/tables', { params: { catalogGuid } })

/** 新增/修改数据表 */
export const saveDbTable = (data) => http.post('/process/table', data)

/** 删除数据表 */
export const deleteDbTable = (guid) => http.delete(`/process/table/${encodeURIComponent(guid)}`)

// ========== 数据库操作辅助 ==========

/** 获取数据库中的所有表/视图 */
export const getDatabaseTables = () => http.get('/process/database/tables-view')

/** 执行 CREATE TABLE 建表语句 */
export const createTable = (data) => http.post('/process/database/create-table', data)

// ========== 流程设计 ==========

/** 获取流程设计 XML（原始旧格式） */
export const getFlowDesign = (flowGuid) => http.get(`/process/design/${encodeURIComponent(flowGuid)}`)

/** 获取完整流程设计（解析 mxGraph XML + DB 节点/连线属性，兼容旧系统） */
export const getFlowDesignParsed = (flowGuid) => http.get(`/process/design/parsed/${encodeURIComponent(flowGuid)}`)

/** 保存流程设计 XML */
export const saveFlowDesign = (data) => http.post('/process/design/save', data)

/** 完整保存流程设计（XML + 节点属性 + 连线属性） */
export const saveFlowDesignFull = (data) => http.post('/process/design/full-save', data)

/** 获取表的列信息 */
export const getTableColumns = (tableName) => http.get('/process/table-columns', { params: { tableName } })

/** 获取下拉框选项数据 */
export const getSelectOptions = (params) => http.get('/process/select-options', { params })

/**
 * 获取节点的按钮配置
 * @param {string} flowGuid - 流程 GUID
 * @param {number} nodeId - 节点 ID
/** 获取流程节点列表（用于调度选择等） */
export const getFlowNodes = (flowGuid) => http.get(`/process/nodes/${encodeURIComponent(flowGuid)}`)

/** 获取节点的按钮配置 */
export const getNodeButtons = (flowGuid, nodeId) => http.get('/process/node-buttons', { params: { flowGuid, nodeId } })

// ========== 图标 ==========

/** 获取菜单图标文件列表（分页） */
export const getIcons = (page = 1, pageSize = 15) => http.get('/process/icons', { params: { page, pageSize } })
